import { safeParseJSON } from "@/utils/File-parsers/safeParseJSON";
import { AcquisitionFormData } from "../DefaultAcqForm";

import {
  FormDataWithCustomAttributes,
  ProcessedCustomAttribute,
} from "../../acquisitions.types";

/**
 * Transform custom_attributes array into individual form field properties
 */
export const transformCustomAttributes = (data?: AcquisitionFormData) => {
  if (!data?.custom_attributes) return {};

  const customFieldValues: Record<string, string | number | string[]> = {};
  data.custom_attributes.forEach((attr) => {
    // Handle TagBox fields that store values as JSON strings
    if (attr.editor_type === "tagBox") {
      customFieldValues[`custom_attribute_${attr.field_id}`] =
        typeof attr.value === "object"
          ? attr.value
          : safeParseJSON(attr.value || "[]");
    } else {
      customFieldValues[`custom_attribute_${attr.field_id}`] = attr.value;
    }
  });

  return customFieldValues;
};

/**
 * Process custom attributes from form data into API format
 */
export const processCustomAttributesForAPI = (
  formData: FormDataWithCustomAttributes
): ProcessedCustomAttribute[] => {
  const customAttributes: ProcessedCustomAttribute[] = [];

  for (const key in formData) {
    if (key.indexOf("custom_attribute_") !== -1) {
      customAttributes.push({
        field_id: parseInt(key.replace("custom_attribute_", "")),
        value: formData[key] as string | number | string[] | null,
      });
      delete formData[key];
    }
  }

  return customAttributes;
};

/**
 * Helper function for array comparison
 */
export const arraysEqual = (arr1: unknown[], arr2: unknown[]): boolean => {
  if (arr1.length !== arr2.length) return false;
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false;
  }
  return true;
};
